import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBookOpen, faArrowUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';

import styles from './DiscoverRomansLink.module.css';

const DISCOVER_ROMANS_URL = 'https://deafchurchwhere.com/resources/discover-romans/';

/**
 * External Discover Romans link shown under the video for ASLV Romans.
 *
 * @returns {JSX.Element} Link bar to the Discover Romans resource.
 */
const DiscoverRomansLink = (): JSX.Element => (
  <a className={styles.link} href={DISCOVER_ROMANS_URL} target="_blank" rel="noopener noreferrer">
    <FontAwesomeIcon className={styles.icon} icon={faBookOpen} />
    <span className={styles.label}>Deaf Bible Discover Romans</span>
    <FontAwesomeIcon className={styles.icon} icon={faArrowUpRightFromSquare} />
  </a>
);

export default DiscoverRomansLink;
